import React from "react";
import { useTheme } from "@emotion/react";
import { Box, Typography, Container } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Navbar } from "../header";

const useStyles = makeStyles((theme) => ({
  main: {
    width: "100vw",
    backgroundColor: "#34566A",
  },
  desktop: {
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  mobile: {
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
}));

export const AboutIntroduction = () => {
  const { main, desktop, mobile } = useStyles();
  const { palette } = useTheme();
  return (
    <>
      <Box className={desktop}>
        <Box className={main}>
          <Container maxWidth="lg">
            <Navbar />
            <Box px={12} pb={7} pt={6}>
              <Typography variant="h1" color={palette.common.white}>
                About Us
              </Typography>
              <Typography variant="body3" color={palette.common.white}>
Word Voyage was created by Adelja Learning Inc, experts in literacy software since 2004. Our first program, Spell Doctor, intercepted spell-checked words from MS Word documents. The words were automatically uploaded to the user's online custom spelling lessons. In 2010, Spell Doctor was relaunched as Word Voyage. A far more comprehensive program, Word Voyage teaches Latin roots, root families, synonyms, parts of speech, spelling, syllables, sentence construction, and grammar. The program is used by thousands of students across the US and abroad.             

 </Typography>
           <Typography variant="body3" color={palette.common.white}>In 2026 Adelja Learning launched <a style={{color: "yellow"}} target="_blank" href="https://www.eyesonpages.com">Eyes on Pages</a>, an AI-driven program that supports and assesses students reading print books. Eyes on Pages also integrates with Word Voyage to help students with unfamiliar vocabulary.
            </Typography>
            </Box>
          </Container>
        </Box>
      </Box>
      <Box className={mobile}>
        <Box className={main}>
          <Container maxWidth="sm">
            <Navbar />
            <Box pb={6} pt={6}>
              <Typography variant="h1" color={palette.common.white}>
                About Us
              </Typography>
              <Typography variant="body3" color={palette.common.white}>
Word Voyage was created by Adelja Learning Inc, experts in literacy software since 2004. Our first program, Spell Doctor, intercepted spell-checked words from MS Word documents. The words were automatically uploaded to the user's online custom spelling lessons. In 2010, Spell Doctor was relaunched as Word Voyage. A far more comprehensive program, Word Voyage teaches Latin roots, root families, synonyms, parts of speech, spelling, syllables, sentence construction, and grammar. The program is used by thousands of students across the US and abroad.              </Typography>
          
           <Typography variant="body3" color={palette.common.white}>In 2026 Adelja Learning launched <a style={{color: "yellow"}} target="_blank" href="https://www.eyesonpages.com">Eyes on Pages</a>, an AI-driven program that supports and assesses students reading print books. Eyes on Pages also integrates with Word Voyage to help students with unfamiliar vocabulary.
            </Typography>
            </Box>
          </Container>
        </Box>
      </Box>
    </>
  );
};
